export enum TogetherTrainingType {
    LORA = "LORA",
    LORA_LONG_CONTEXT = "LORA_LONG_CONTEXT",
    FULL = "FULL",
}
